import React, { useState, useCallback } from 'react';

import Grid from '@mui/material/Grid';

import { postAuthToken } from '@src/services/api/auth-token';

import CheckNotLogin from '@src/components/layouts/CheckNotLogin';
import { LoginForm } from '@src/components/login';

const Login = () => {
    const [values, setValues] = useState({ login: '', password: '' });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        postAuthToken(values).then((data) => {
            window.localStorage.setItem('jwt', data.jwt);
            window.location.pathname = '/';
        }).catch((error) => {
            setError(error.message);
            setLoading(false);
        });
    }, [values, setError]);

    const handleFieldChange = React.useCallback((e) => {
        e.persist();
        setValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
        }));
    }, [setValues]);

    return (
        <CheckNotLogin>
            <Grid container sx={{ width: '100%' }} justifyContent="center" alignItems="center">
                <Grid size={{ xs: 12, sm: 9, md: 6 }}>
                    <LoginForm
                        values={values}
                        error={error}
                        loading={loading}
                        onSubmit={handleSubmit}
                        onFieldChange={handleFieldChange}
                    />
                </Grid>
            </Grid>
        </CheckNotLogin>
    );
};

export default Login;
